import { Controller } from '@hotwired/stimulus'
import { showToast } from '../lib/toastr'
import { showAdminFlash } from '../lib/admin_flash'

const ACTIVE_CLASS = 'file-drop-zone--active'
// Must stay in sync with FileFieldComponent#zone_label_class, which applies the same class
// server-side when a file has already been uploaded.
const FILLED_LABEL_CLASS = 'text-decoration-underline'
const FILLED_ZONE_CLASS = 'border-primary-950'

export default class extends Controller {
  static targets = ['input', 'dropZone', 'label']

  static values = {
    acceptedTypes: Array,
    invalidTypeMessage: String,
    notificationStyle: { type: String, default: 'toast' },
  }

  openDialog() {
    this.inputTarget.click()
  }

  dragOver(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add(ACTIVE_CLASS)
  }

  dragLeave() {
    this.dropZoneTarget.classList.remove(ACTIVE_CLASS)
  }

  drop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove(ACTIVE_CLASS)

    const file = event.dataTransfer.files[0]
    if (!file) return

    if (!this.acceptedTypesValue.includes(file.type)) {
      this.#showError(this.invalidTypeMessageValue)
      return
    }

    this.inputTarget.files = event.dataTransfer.files
    this.#updateLabel(file.name)
  }

  fileSelected() {
    if (this.inputTarget.files.length > 0) {
      this.#updateLabel(this.inputTarget.files[0].name)
    }
  }

  #updateLabel(filename) {
    this.labelTarget.textContent = filename
    this.labelTarget.classList.add(FILLED_LABEL_CLASS)
    this.dropZoneTarget.classList.add(FILLED_ZONE_CLASS)
  }

  #showError(message) {
    if (this.notificationStyleValue === 'admin-flash') {
      showAdminFlash('error', message)
      return
    }

    showToast('error', message)
  }
}
